export function changeInput(input) {
  if (input.target.type === "checkbox") {
    if (!input.target.checked) {
      input.target.classList.add("error");
    } else {
      input.target.classList.remove("error");
    }
  } else {
    if (!input.target.value.trim()) {
      input.target.classList.add("error");
      input.target.nextElementSibling.innerHTML = "Заполните это поле";
    } else if (input.target.value.trim().length <= 2) {
      input.target.classList.add("error");
      input.target.nextElementSibling.innerHTML =
        "Поле должно содержать не менее 3 символов";
    } else {
      input.target.classList.remove("error");
      input.target.nextElementSibling.innerHTML = "";
    }
  }
}
